
export const setFilter = (car, filter, start=null, end=null) => ({
	type: 'SET_VISIBILITY_FILTER',
	car,
	filter,
	start,
	end
})

export const signIn = (id,name,email) => ({
	type: 'LOG_USER_IN',
	id,
	name,
	email
})

export const initApp = (cars) => ({
	type: 'INIT',
	cars
})

export const addFillup = (props) => ({
	type: 'ADD_FILLUP',
	...props
})

export const newVehicle = (props) => ({
	type: 'NEW_VEHICLE',
	...props
})

export const signOut = () => ({
	type: 'SIGN_OUT'
})



export const doConnectionState = (connected) => ({
	type: 'STATE_CHANGE',
	connected
})





// WEBPACK FOOTER //
// ./src/actions/index.js